import React, { useEffect, useState } from "react";
import { Layout, Menu, message } from "antd";
import { Link, useHistory, useRouteMatch } from "react-router-dom";
import { Box, IconButton, Typography, useTheme, Collapse } from "@mui/material";
import { tokens } from "../../theme";
import dashboard_pressed from "../../assets/img/Dahsboard_pressed.png";
import dashboard_ico from "../../assets/img/Dashboard.png";
import loan_ico from "../../assets/img/LoanLogo.png";
import loan_pressed from "../../assets/img/LoanLogo_pressed.png";
import agreements_ico from "../../assets/img/Agreementlogo.png";
import agreements_pressed from "../../assets/img/Agreementlogo_pressed.png";
import subscription_ico from "../../assets/img/Subscription.png";
import subscription_pressed from "../../assets/img/SubscriptionLogo_pressed.png";
import profile_ico from "../../assets/img/Profile.png";
import profile_pressed from "../../assets/img/Profile_selected.png";
import logout_ico from "../../assets/img/Logout.png";
import LockIcon from "@mui/icons-material/Lock";
import SidebarMobile from "./SidebarMobile";
import Hamburger from "hamburger-react";
import { fallDown as BurgerMenu } from "react-burger-menu";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import Cookies from "js-cookie";
import Tour from "reactour";
import TourIcon from "@mui/icons-material/Tour";
import ReviewsIcon from "@mui/icons-material/Reviews";
import { Modal, Tooltip } from "antd";
import {
  UserOutlined,
  UploadOutlined,
  QuestionOutlined,
} from "@ant-design/icons";
import FolderSpecialIcon from "@mui/icons-material/FolderSpecial";
import ForumIcon from "@mui/icons-material/Forum";
import newLogo from "../../pages/smart-lend-frontend/src/img/sl_long_new_logo_wo_beta.png";
import GroupsIcon from "@mui/icons-material/Groups";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import EmailIcon from "@mui/icons-material/Email";
import LogoutIcon from "@mui/icons-material/Logout";
import WelcomeWizard from "./WelcomeWizard";
import { displayName } from "react-quill";

const BRAND = "var(--br-primary, rgb(14, 90, 165))";
const BRAND2 = "rgb(109, 92, 246)"; // accent similar to wizard
const SIDE_BG = `radial-gradient(900px 420px at 10% 8%, rgba(var(--br-primary-rgb, 14,90,165), 0.22), transparent 60%),
radial-gradient(900px 520px at 90% 18%, rgba(109,92,246,0.18), transparent 55%),
radial-gradient(700px 520px at 60% 95%, rgba(var(--br-primary-rgb, 14,90,165), 0.10), transparent 55%),
linear-gradient(180deg, rgba(255,255,255,0.75) 0%, rgba(243,247,255,1) 55%, rgba(241,246,249,1) 100%)`;

const glassPanel = {
  background: "var(--br-surface, rgba(255,255,255,0.72))",
  border: "1px solid rgba(148,163,184,0.28)",
  boxShadow: "var(--br-shadow, 0 18px 46px rgba(2, 8, 23, 0.08))",
  borderRadius: "var(--br-card-radius, 22px)",
  overflow: "hidden",
  height: "100%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
};

const menuBaseStyle = {
  background: "transparent",
  borderRight: "none",
  padding: "0 16px 0px 0px", // ✅ gives room for shadow inside
  overflow: "visible", // ✅ allow shadow
};
const MOBILE_SIDEBAR_BG = `radial-gradient(900px 420px at 10% 8%, rgba(var(--br-primary-rgb, 14,90,165), 0.22), transparent 60%),
radial-gradient(900px 520px at 90% 18%, rgba(109,92,246,0.18), transparent 55%),
radial-gradient(700px 520px at 60% 95%, rgba(var(--br-primary-rgb, 14,90,165), 0.10), transparent 55%),
linear-gradient(180deg, rgba(255,255,255,0.78) 0%, rgba(243,247,255,1) 55%, rgba(241,246,249,1) 100%)`;

const mobileGlassPanel = {
  background: "var(--br-surface, rgba(255,255,255,0.78))",
  border: "1px solid rgba(148,163,184,0.24)",
  boxShadow: "var(--br-shadow, 0 18px 46px rgba(2, 8, 23, 0.10))",
  borderRadius: "var(--br-card-radius, 22px)",
  overflow: "hidden",
};

const burgerMenuStyles = {
  bmOverlay: {
    background: "rgba(2, 8, 23, 0.45)",
    backdropFilter: "blur(10px)",
    WebkitBackdropFilter: "blur(10px)",
  },
  bmMenuWrap: {
    top: 0,
    height: "100%",
  },
  bmMenu: {
    padding: "0px",
    background: MOBILE_SIDEBAR_BG,
  },
  bmItemList: {
    padding: "18px 14px",
  },
};

const { Sider } = Layout;
const { SubMenu } = Menu;

const Item3 = ({ title, to, icon, icon2, onClick, disabled }) => {
  const [hovered, setHovered] = useState(false);

  return (
    <Menu.Item
      className="sl-borrower-nav-action"
      key={title}
      icon={hovered ? icon : icon2}
      style={{
        margin: "10px 12px 14px 3px",
        borderRadius: "var(--br-card-radius, 16px)",
        paddingLeft: 14,
        height: 46,
        display: "flex",
        alignItems: "center",
        gap: 10,
        background: hovered
          ? "linear-gradient(180deg, rgba(239,68,68,0.10) 0%, rgba(239,68,68,0.05) 100%)"
          : "var(--br-surface, rgba(255,255,255,0.60))",
        border: hovered
          ? "1px solid rgba(239,68,68,0.22)"
          : "1px solid rgba(148,163,184,0.20)",
        boxShadow: hovered
          ? "var(--br-shadow, 0 14px 34px rgba(239,68,68,0.12))"
          : "var(--br-shadow, 0 8px 18px rgba(2,8,23,0.06))",
        cursor: disabled ? "not-allowed" : "pointer",
        opacity: disabled ? 0.65 : 1,
        transition:
          "transform .12s ease, box-shadow .12s ease, background .12s ease",
        color: "rgba(15,23,42,0.78)",
        fontFamily: "Manrope, sans-serif",
        fontWeight: 900,
        fontSize: 13,
      }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onClick={(e) => {
        if (!disabled) onClick?.(e);
      }}
      disabled={disabled}
    >
      {title}
      {to ? <Link to={to} /> : null}
    </Menu.Item>
  );
};

const MONEY_LENDER_CAMPAIGN_COOKIE = "money_lender_campaign_data";

const Sidebar = ({ to, userDetails }) => {
  const urlPram = useHistory();

  const [anyUnread, setAnyUnread] = useState(false);
  const [isTourOpen, setIsTourOpen] = useState(false);
  const [verifiedStatus, setVerifiedStatus] = useState(
    parseFloat(Cookies.get("verificationStatus")) || 0
  );
  const [loanExist, setLoanExist] = useState(
    parseFloat(Cookies.get("loanExist") || 0)
  );
  const [AccountManagerExist, setAccountManagerExist] = useState(
    parseFloat(Cookies.get("accountmanagerexist") || 0)
  );

  const fetchLoanCount = async () => {
    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", "Bearer " + Cookies.get("token"));

    const options = {
      method: "GET",
      headers: headers,
    };

    try {
      const response = await fetch(
        "https://www.smart-lend.com/api/loan/checkLoanRequestCount",
        options
      );

      if (!response.ok) {
        throw new Error("Failed to fetch data");
      } else {
        const data = await response.json();
        if (data.loanRequestCount > 0) {
          setLoanExist(true);
          Cookies.set("loanExist", 1);
        } else {
          setLoanExist(false);
          Cookies.set("loanExist", 0);
        }
      }
    } catch (error) {
      console.error(error);
    }
  };
  const [accountManagerDetails, setAccountManagerDetails] = useState(null);
  const [accountmanagerModalIsOpen, setAccountmanagerModalIsOpen] =
    useState(false);

  const getAccountManagerDetails = async () => {
    try {
      const response = await fetch(
        `https://www.smart-lend.com/api/user/getAccountManagerDetails`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + Cookies.get("token"),
          },
        }
      );
      if (response.status === 200) {
        const json = await response.json();
        if (json.accountManager !== null) {
          setAccountManagerExist(true);
          Cookies.set("accountmanagerexist", 1);
          setAccountManagerDetails(JSON.parse(json.accountManager));
        } else {
          setAccountManagerExist(false);
          Cookies.set("accountmanagerexist", 0);
        }
      } else if (response.status === 401) {
        Cookies.remove("token");
        window.location.href = "/auth/signin";
      }
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    getAccountManagerDetails();
  }, []);

  useEffect(() => {
    fetchLoanCount();
    if (Cookies.get("signupthroughcbs")) {
      history.push("/b-cbs-campaign");
    }
  }, []);

  const getUserVerificationFiles = async () => {
    try {
      const response = await fetch(
        `https://www.smart-lend.com/api/user/getUserVerificationFiles`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + Cookies.get("token"),
          },
        }
      );

      if (response.ok) {
        const json = await response.json();
        if (json.verificationStatus === 0 || json.verificationStatus === 1) {
          setVerifiedStatus(json.verificationStatus);
          Cookies.set("verificationStatus", json.verificationStatus);
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  const [isWizardOpen, setIsWizardOpen] = useState(false);
  const [showCampaignPrompt, setShowCampaignPrompt] = useState(false);
  const [campaignPromptBusy, setCampaignPromptBusy] = useState(false);

  const hasMoneyLenderCampaign = () => Boolean(Cookies.get(MONEY_LENDER_CAMPAIGN_COOKIE));

  const handleCampaignSingpassSync = async () => {
    try {
      setCampaignPromptBusy(true);
      const token = Cookies.get("token");
      if (!token) {
        history.push("/auth/signin");
        return;
      }

      Cookies.set("sync_source", "money_lender_campaign", { path: "/", expires: 30 });

      const response = await fetch(`https://www.smart-lend.com/api/generateCodeChallenge`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ type: "borrower" }),
      });

      const json = await response.json();
      if (response.ok && json?.singpass_url && json?.session_id) {
        Cookies.set("latest_session_id", json.session_id, { path: "/" });
        window.location.href = json.singpass_url;
        return;
      }

      throw new Error(json?.message || "Unable to start Singpass sync");
    } catch (error) {
      console.error(error);
      message.error("Unable to start Singpass sync right now. Please try again.");
    } finally {
      setCampaignPromptBusy(false);
    }
  };

  useEffect(() => {
    console.log(Cookies.get("verificationStatus"));
    getUserVerificationFiles();
  }, []);

  useEffect(() => {
    const checkWelcomeWizard = async () => {
      if (!userDetails) return;

      if (Cookies.get("vpnToAccount") === "true") {
        Cookies.remove("vpnToAccount");
        setIsWizardOpen(false);
        return;
      }

      if (!userDetails.mobile_no) {
        setIsWizardOpen(true);
        return;
      }

      try {
        const response = await fetch(
          "https://www.smart-lend.com/api/user/welcome-wizard",
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + Cookies.get("token"),
            },
          }
        );

        if (!response.ok) {
          throw new Error("Failed to fetch welcome wizard status");
        }

        const data = await response.json();
        if (!data.exists) {
          setIsWizardOpen(true);
          return;
        }

        if (!Cookies.get("tourDone")) {
          console.log("testing tour next");
          setIsTourOpen(true);
          Cookies.set("tourDone", true);
        }
      } catch (error) {
        console.error(error);
        setIsWizardOpen(true);
      }
    };

    checkWelcomeWizard();
  }, [userDetails]);

  const tourSteps = [
    {
      selector: ".step1",
      content:
        "Welcome to SmartLend! Ready to start your business loan application?",
    },
    {
      selector: ".step2",
      content:
        "Scan your Corppass to quickly fill out your application details",
    },
    {
      selector: ".step3",
      content: "Apply for your loan here and get access to multiple lenders.",
    },
    {
      selector: ".step4",
      content:
        "Compare and choose the best loan offer that suits your business needs.",
    },
    {
      selector: ".step5",
      content:
        "Complete your loan agreement to access funds for your working capital needs.",
    },
    {
      selector: ".step6",
      content: "Check your on-going loan and terms. ",
    },
    {
      selector: ".step7",
      content: "And that's it! Ready to start your business loan application?",
    },
  ];

  const [feedbackModal, setFeedbackModal] = useState(false);
  const handleWizardFinish = () => {
    setIsWizardOpen(false);

    if (hasMoneyLenderCampaign()) {
      setShowCampaignPrompt(true);
    }

    if (!Cookies.get("tourDone")) {
      setIsTourOpen(true);
      Cookies.set("tourDone", true);
    }
  };
  const Item = ({
    className,
    title,
    title2,
    to,
    icon,
    icon2,
    selected,
    setSelected,
    blinking,
    isNew = false,
  }) => {
    const match = useRouteMatch(to);
    const [hovered, setHovered] = useState(false);

    const isActive = Boolean(match);
    const isDisabled = to === "/b-coming-soon";

    const baseTextColor = isDisabled
      ? "rgba(148,163,184,0.75)"
      : isActive
      ? "rgba(15,23,42,0.88)"
      : "rgba(15,23,42,0.62)";

    return (
      <div className={blinking ? "blink" : ""}>
        <Menu.Item
          className={["sl-borrower-nav-item", isActive ? "is-active" : "", isDisabled ? "is-disabled" : "", className].filter(Boolean).join(" ")}
          aria-current={isActive ? "page" : undefined}
          icon={isActive ? icon : icon2}
          style={{
            borderRadius: "var(--br-card-radius, 16px)",
            paddingLeft: 14,
            paddingRight: 12,
            height: title ? 46 : 38,
            display: "flex",
            alignItems: "center",
            gap: 10,
            position: "relative",
            background: isActive
              ? "linear-gradient(180deg, rgba(var(--br-primary-rgb, 14,90,165), 0.12) 0%, rgba(109,92,246,0.06) 100%)"
              : hovered
              ? "var(--br-surface, rgba(255,255,255,0.85))"
              : "var(--br-surface, rgba(255,255,255,0.60))",
            border: isActive
              ? "1px solid rgba(var(--br-primary-rgb, 14,90,165), 0.22)"
              : "1px solid rgba(148,163,184,0.20)",
            boxShadow: isActive
              ? "var(--br-shadow, 0 14px 34px rgba(var(--br-primary-rgb, 14,90,165), 0.12))"
              : hovered
              ? "var(--br-shadow, 0 12px 26px rgba(2,8,23,0.08))"
              : "var(--br-shadow, 0 8px 18px rgba(2,8,23,0.06))",
            cursor: isDisabled ? "not-allowed" : "pointer",
            opacity: isDisabled ? 0.75 : 1,
            transition:
              "transform .12s ease, box-shadow .12s ease, background .12s ease",
            marginLeft: icon2 === " " ? 20 : 0,
            width: icon2 === " " ? "calc(100% - 20px)" : "100%",
            marginTop: "8px",
          }}
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
          onClick={() => {
            if (!isDisabled) setSelected(title || title2 || selected);
          }}
        >
          {/* left active glow bar */}
          {isActive ? (
            <div
              style={{
                position: "absolute",
                left: 0,
                top: 10,
                bottom: 10,
                width: 6,
                borderRadius: 999,
                background: `linear-gradient(180deg, ${BRAND} 0%, ${BRAND2} 120%)`,
                boxShadow: "var(--br-shadow, 0 10px 18px rgba(var(--br-primary-rgb, 14,90,165), 0.20))",
              }}
            />
          ) : null}

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              lineHeight: 1.1,
            }}
          >
            {title ? (
              <div
                style={{
                  fontFamily: "Manrope, sans-serif",
                  fontWeight: 900,
                  fontSize: 13,
                  color: baseTextColor,
                }}
              >
                {title}
              </div>
            ) : null}

            {title2 ? (
              <div
                className={isNew ? "sl-borrower-nav-new-label" : undefined}
                style={{
                  fontFamily: "Manrope, sans-serif",
                  fontWeight: 800,
                  fontSize: 12,
                  color: baseTextColor,
                  paddingLeft: title ? 0 : 12,
                }}
              >
                {isNew ? <span>{title2}</span> : title2}
                {isNew && <span className="sl-borrower-nav-new-badge">NEW</span>}
              </div>
            ) : null}
          </div>

          {anyUnread && title === "Messages" ? (
            <div
              className="blink"
              style={{
                position: "absolute",
                width: 8,
                height: 8,
                borderRadius: "50%",
                background: BRAND,
                right: 14,
                top: 14,
                boxShadow: "var(--br-shadow, 0 10px 18px rgba(var(--br-primary-rgb, 14,90,165), 0.22))",
              }}
            />
          ) : null}

          {!isDisabled ? <Link to={to} /> : null}
        </Menu.Item>
      </div>
    );
  };

  const checkReadId = (data, currentUserId) => {
    if (!Array.isArray(data) || !currentUserId) {
      setAnyUnread(false);
      return;
    }

    const isRead = (value) =>
      value === true || value === 1 || value === "1" || value === "true";

    const hasUnread = data.some((conversation) => {
      if (conversation.user_id1 === currentUserId) {
        return !isRead(conversation.read_id1);
      }

      if (conversation.user_id2 === currentUserId) {
        return !isRead(conversation.read_id2);
      }

      return false;
    });

    setAnyUnread(hasUnread);
  };

  const retrieveMessage = async () => {
    try {
      const response = await fetch(
        "https://www.smart-lend.com/api/message/getMessage",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
        }
      );

      const json = await response.json();
      if (response.status === 200) {
        const data = [...json.data];
        console.log("updated new data");
        checkReadId(data, json.user_id);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      retrieveMessage();
    }, 6000);

    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    retrieveMessage();
  }, []);
  useEffect(() => {
    // Function to get the value of a URL parameter by name
    const getUrlParameter = (name) => {
      name = name.replace(/[[]/, "\\[").replace(/[\]]/, "\\]");
      const regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
      const results = regex.exec(window.location.search);
      return results === null
        ? ""
        : decodeURIComponent(results[1].replace(/\+/g, " "));
    };

    // Get the token parameter from the URL
    const tokenParam = getUrlParameter("token");

    // Check if a token is present in the URL
    if (tokenParam) {
      // Store the token in cookies
      Cookies.set("token", tokenParam, { expires: 7 }); // Set an expiration if needed

      // Remove the token parameter from the URL
      const urlWithoutToken =
        window.location.pathname +
        window.location.search
          .replace(/([&?])token=[^&]+(&|$)/, "$1")
          .replace(/(&|\?)$/, "");

      // Replace the current URL without adding a new entry to the browser urlPram
      urlPram.replace(urlWithoutToken);
    }
  }, [urlPram]);
  const match = useRouteMatch(to);
  const [isLoading, setIsLoading] = useState(false);

  const handleLogout = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(
        "https://www.smart-lend.com/api/user/logout",
        {
          method: "POST",
          redirect: "manual", // don't follow the redirect
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
        }
      );
      console.log("response status value", response.status);
      if (response.status === 200) {
        // Clear user session and navigate to login page
        Cookies.remove("token");
        window.location.href = "/auth/signin";
      } else if (response.status === 0) {
        Cookies.remove("token");
        window.location.href = "/auth/signin";
      } else if (response.status === 401) {
        Cookies.remove("token");
        window.location.href = "/auth/signin";
      }
      // if (!response.ok) {
      //   throw new Error("Logout failed");
      // }
    } catch (error) {
      console.error(error);
      // Display error message to user
      window.location.href = "/auth/signin";
    }
    setIsLoading(false);
  };
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [selected, setSelected] = useState("Dashboard");

  const toggleCollapsed = () => {
    setIsCollapsed(isCollapsed);
  };

  const [screenWidth, setScreenWidth] = useState("1920");

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    // Call handleResize initially to set the initial screen width
    handleResize();

    // Add event listener for resize
    window.addEventListener("resize", handleResize);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const history = useHistory();

  const [menuIsOpen, setMenuIsOpen] = useState(false);

  const [feedbackForm, setFeedbackForm] = useState({
    category: "",
    image: "",
    message: "",
    status_1: "",
    status_2: "",
    status_3: "",
  });

  function handleToggleMenu(event) {
    setMenuIsOpen(!menuIsOpen);
  }
  const handleFileChange = async (file) => {
    const formData = new FormData();
    console.log(file);
    formData.append("file", file);
    try {
      const response1 = await fetch(
        "https://www.smart-lend.com/api/file/uploadUniversalFile",
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
          body: formData,
        }
      );
      if (response1.status === 200) {
        const data = await response1.json();
        const imageUrl = data.url;
        console.log({ ...feedbackForm, image: imageUrl });
        setFeedbackForm({ ...feedbackForm, image: imageUrl });
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleCreateFeedback = async () => {
    try {
      let dataTosend = {
        submission_data: JSON.stringify({
          category: feedbackForm.category,
          image: feedbackForm.image,
          message: feedbackForm.message,
        }),
        status_1: "created",
        status_2: "",
        status_3: "",
      };
      const response = await fetch(
        "https://www.smart-lend.com/api/user/feedback/createFeedback",
        {
          method: "POST",
          body: JSON.stringify(dataTosend),
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
        }
      );

      if (response.status === 200) {
        const json = await response.json();
        console.log(json);
        setFeedbackModal(false);
        message.success("Your feedback has been submitted!");
      }
    } catch (error) {
      console.error(error);
    }
  };
  const MobileItem = ({
    title,
    title2,
    to,
    icon,
    icon2,
    onClick,
    blinking,
    indent = false,
    isNew = false,
  }) => {
    const match = useRouteMatch(to);
    const [hovered, setHovered] = useState(false);

    const isActive = Boolean(match);
    const isDisabled = to === "/b-coming-soon";

    const label = title || title2;

    const baseTextColor = isDisabled
      ? "rgba(148,163,184,0.75)"
      : isActive
      ? "rgba(15,23,42,0.88)"
      : "rgba(15,23,42,0.62)";

    return (
      <div className={blinking ? "blink" : ""}>
        <div
          className={["sl-borrower-nav-item", isActive ? "is-active" : "", isDisabled ? "is-disabled" : ""].filter(Boolean).join(" ")}
          aria-current={isActive ? "page" : undefined}
          onClick={() => {
            if (isDisabled) return;
            onClick?.();
          }}
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
          style={{
            borderRadius: "var(--br-card-radius, 16px)",
            padding: indent ? "12px 12px 12px 18px" : "12px 14px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 12,
            position: "relative",
            margin: "10px 6px",
            cursor: isDisabled ? "not-allowed" : "pointer",
            opacity: isDisabled ? 0.75 : 1,

            background: isActive
              ? "linear-gradient(180deg, rgba(var(--br-primary-rgb, 14,90,165), 0.12) 0%, rgba(109,92,246,0.06) 100%)"
              : hovered
              ? "var(--br-surface, rgba(255,255,255,0.85))"
              : "var(--br-surface, rgba(255,255,255,0.70))",

            border: isActive
              ? "1px solid rgba(var(--br-primary-rgb, 14,90,165), 0.22)"
              : "1px solid rgba(148,163,184,0.22)",

            boxShadow: isActive
              ? "var(--br-shadow, 0 14px 34px rgba(var(--br-primary-rgb, 14,90,165), 0.12))"
              : hovered
              ? "var(--br-shadow, 0 12px 26px rgba(2,8,23,0.08))"
              : "var(--br-shadow, 0 10px 22px rgba(2,8,23,0.06))",

            transition:
              "transform .12s ease, box-shadow .12s ease, background .12s ease",
          }}
        >
          {/* left active glow bar (same vibe as desktop) */}
          {isActive ? (
            <div
              style={{
                position: "absolute",
                left: 0,
                top: 10,
                bottom: 10,
                width: 6,
                borderRadius: 999,
                background: `linear-gradient(180deg, ${BRAND} 0%, ${BRAND2} 120%)`,
                boxShadow: "var(--br-shadow, 0 10px 18px rgba(var(--br-primary-rgb, 14,90,165), 0.20))",
              }}
            />
          ) : null}

          {/* Left: icon + text */}
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            {icon2 === " " ? (
              <div style={{ width: 18 }} />
            ) : (
              <div style={{ width: 18, display: "flex", alignItems: "center" }}>
                {isActive ? icon : icon2}
              </div>
            )}

            <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
              <div
                className={isNew ? "sl-borrower-nav-new-label" : undefined}
                style={{
                  fontFamily: "Manrope, sans-serif",
                  fontWeight: title ? 900 : 800,
                  fontSize: title ? 13 : 12,
                  color: baseTextColor,
                }}
              >
                {isNew ? <span>{label}</span> : label}
                {isNew && <span className="sl-borrower-nav-new-badge">NEW</span>}
              </div>

              {/* optional subtitle for indented items (nice mobile hint) */}
              {/* {indent ? (
                <div
                  style={{
                    fontFamily: "Manrope, sans-serif",
                    fontWeight: 700,
                    fontSize: 11,
                    color: "rgba(15,23,42,0.45)",
                  }}
                >
                  {title2?.includes("Document") ? "Under Tools" : "Under Loan"}
                </div>
              ) : null} */}
            </div>
          </div>

          {/* unread dot (same rule as desktop) */}
          {anyUnread && title === "Messages" ? (
            <div
              className="blink"
              style={{
                position: "absolute",
                width: 8,
                height: 8,
                borderRadius: "50%",
                background: BRAND,
                right: 40,
                top: 16,
                boxShadow: "var(--br-shadow, 0 10px 18px rgba(var(--br-primary-rgb, 14,90,165), 0.22))",
              }}
            />
          ) : null}

          <NavigateNextIcon style={{ color: "rgba(15,23,42,0.35)" }} />
        </div>
      </div>
    );
  };

  return (
    <>
      <WelcomeWizard
        isOpen={isWizardOpen}
        userDetails={userDetails}
        accountManagerExist={AccountManagerExist}
        onFinish={handleWizardFinish}
        onOpenAccountManager={() => setAccountmanagerModalIsOpen(true)}
      />
      <Modal
        open={showCampaignPrompt}
        onCancel={() => setShowCampaignPrompt(false)}
        footer={null}
        centered
      >
        <div style={{ textAlign: "center" }}>
          <div style={{ fontSize: 24, fontWeight: 800, color: "var(--br-primary, #0e5aa5)" }}>
            Continue your personal loan application
          </div>
          <div style={{ color: "rgba(0,0,0,0.65)", marginTop: 10, lineHeight: 1.5 }}>
            We noticed you were interested in a money lender personal loan.
            Would you like to proceed now by syncing your Singpass MyInfo details?
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: 12,
              marginTop: 20,
              flexWrap: "wrap",
            }}
          >
            <button
              type="button"
              onClick={handleCampaignSingpassSync}
              disabled={campaignPromptBusy}
              style={{
                border: "none",
                borderRadius: "var(--br-card-radius, 10px)",
                padding: "10px 16px",
                background: "linear-gradient(135deg, var(--br-primary, #0e5aa5) 0%, #6d5cf6 120%)",
                color: "#fff",
                fontWeight: 700,
                cursor: campaignPromptBusy ? "not-allowed" : "pointer",
                opacity: campaignPromptBusy ? 0.7 : 1,
              }}
            >
              {campaignPromptBusy ? "Starting sync..." : "Sync Singpass"}
            </button>
            <button
              type="button"
              onClick={() => setShowCampaignPrompt(false)}
              style={{
                borderRadius: "var(--br-card-radius, 10px)",
                padding: "10px 16px",
                border: "1px solid rgba(0,0,0,0.2)",
                background: "var(--br-surface, #fff)",
                fontWeight: 600,
                cursor: "pointer",
              }}
            >
              Maybe later
            </button>
          </div>
        </div>
      </Modal>
      {screenWidth > 1200 ? (
        <>
          {/* Account Manager Modal */}
          <Modal
            style={{ backgroundColor: "rgba(0, 0, 0, 0)" }}
            open={accountmanagerModalIsOpen}
            onCancel={() => setAccountmanagerModalIsOpen(false)}
            footer={null}
          >
            {accountManagerDetails ? (
              <div
                style={{
                  color: "rgba(0,0,0,0.4)",
                  fontSize: "10px",
                  fontFamily: "Manrope, sans-serif",
                  fontWeight: 500,
                }}
              >
                <div
                  style={{
                    color: "var(--br-text, #142C44CC)",
                    fontSize: "18px",
                    fontFamily: "Manrope, sans-serif",
                    fontWeight: 900,
                  }}
                >
                  Account Manager details
                </div>

                <div style={{ display: "flex", gap: 22, marginTop: 12 }}>
                  {accountManagerDetails?.profile ? (
                    <img
                      style={{
                        height: 84,
                        width: 84,
                        borderRadius: "50%",
                        objectFit: "cover",
                        boxShadow: "var(--br-shadow, 0 14px 34px rgba(2,8,23,0.14))",
                        border: "1px solid rgba(148,163,184,0.25)",
                      }}
                      src={accountManagerDetails.profile}
                      alt=""
                    />
                  ) : null}

                  <div style={{ flex: 1 }}>
                    <div style={{ marginTop: 2 }}>Name</div>
                    <div
                      style={{
                        color: "var(--br-text, #142C44CC)",
                        fontSize: 12,
                        fontFamily: "Manrope, sans-serif",
                        fontWeight: 800,
                      }}
                    >
                      {accountManagerDetails.name || "Not provided"}
                    </div>

                    <div style={{ marginTop: 10 }}>Phone number</div>
                    <div
                      className="mui_button"
                      onClick={() => {
                        if (accountManagerDetails.ph) {
                          const cleanPhone = accountManagerDetails.ph
                            .replace(/\D/g, "")
                            .replace(/^0+/, "");
                          window.location.href = `https://wa.me/${cleanPhone}`;
                        }
                      }}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 10,
                        padding: "10px 12px",
                        borderRadius: "var(--br-card-radius, 14px)",
                        background: "var(--br-surface, rgba(255,255,255,0.72))",
                        border: "1px solid rgba(148,163,184,0.22)",
                        boxShadow: "var(--br-shadow, 0 12px 26px rgba(2,8,23,0.07))",
                        width: "fit-content",
                      }}
                    >
                      {accountManagerDetails.ph ? (
                        <WhatsAppIcon
                          style={{ color: "var(--br-text, #142C44CC)", fontSize: 22 }}
                        />
                      ) : null}
                      <div
                        style={{
                          color: "var(--br-text, #142C44CC)",
                          fontSize: 12,
                          fontFamily: "Manrope, sans-serif",
                          fontWeight: 800,
                        }}
                      >
                        {accountManagerDetails.ph || "Not provided"}
                      </div>
                    </div>

                    <div style={{ marginTop: 10 }}>Email</div>
                    <div
                      className="mui_button"
                      onClick={() => {
                        if (accountManagerDetails.email) {
                          window.location.href = `mailto:${accountManagerDetails.email}`;
                        }
                      }}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 10,
                        padding: "10px 12px",
                        borderRadius: "var(--br-card-radius, 14px)",
                        background: "var(--br-surface, rgba(255,255,255,0.72))",
                        border: "1px solid rgba(148,163,184,0.22)",
                        boxShadow: "var(--br-shadow, 0 12px 26px rgba(2,8,23,0.07))",
                        width: "fit-content",
                      }}
                    >
                      {accountManagerDetails.email ? (
                        <EmailIcon
                          style={{ color: "var(--br-text, #142C44CC)", fontSize: 22 }}
                        />
                      ) : null}
                      <div
                        style={{
                          color: "var(--br-text, #142C44CC)",
                          fontSize: 12,
                          fontFamily: "Manrope, sans-serif",
                          fontWeight: 800,
                        }}
                      >
                        {accountManagerDetails.email || "Not provided"}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : null}
          </Modal>

          {/* Feedback Modal */}
          <Modal
            width={screenWidth < 1200 ? "100%" : "50%"}
            style={{ backgroundColor: "rgba(0, 0, 0, 0)" }}
            open={feedbackModal}
            onCancel={() => setFeedbackModal(false)}
            footer={null}
          >
            <div
              style={{
                color: "var(--br-text, #142C44CC)",
                fontWeight: 900,
                fontSize: 18,
                fontFamily: "Manrope, sans-serif",
              }}
            >
              Please leave your feedback below as detailed as it can be.
            </div>

            <form
              onSubmit={(e) => {
                e.preventDefault();
                handleCreateFeedback();
              }}
            >
              <div style={{ marginTop: 12, marginBottom: 6, fontSize: 13 }}>
                Select a category for your feedback submission.
              </div>

              <select
                style={{
                  fontSize: 13,
                  fontWeight: 700,
                  borderRadius: "var(--br-card-radius, 14px)",
                  padding: "10px 12px",
                  width: "100%",
                  border: "1px solid rgba(148,163,184,0.28)",
                  background: "var(--br-surface, rgba(255,255,255,0.78))",
                }}
                value={feedbackForm.category}
                onChange={(e) =>
                  setFeedbackForm({ ...feedbackForm, category: e.target.value })
                }
              >
                <option value={""}>Select a category</option>
                <option value={"Report a bug"}>Report a bug</option>
                <option value={"Request a feature"}>Request a feature</option>
                <option value={"Suggest an improvement"}>
                  Suggest an improvement
                </option>
                <option value={"Report a user"}>Report a user</option>
                <option value={"None of the above"}>None of the above</option>
              </select>

              <div style={{ marginTop: 12, marginBottom: 6, fontSize: 13 }}>
                If you have a screenshot of a problem, you may upload it here.
              </div>
              <input
                type="file"
                accept="image/*"
                style={{ fontSize: 12, fontWeight: 600 }}
                onChange={(e) => handleFileChange(e.target.files[0])}
              />

              <div style={{ marginTop: 12, marginBottom: 6, fontSize: 13 }}>
                Provide a detailed description of the feedback.
              </div>
              <textarea
                value={feedbackForm.message}
                onChange={(e) =>
                  setFeedbackForm({ ...feedbackForm, message: e.target.value })
                }
                style={{
                  resize: "none",
                  width: "100%",
                  fontSize: 13,
                  fontWeight: 700,
                  padding: 12,
                  height: "14vh",
                  borderRadius: "var(--br-card-radius, 14px)",
                  border: "1px solid rgba(148,163,184,0.28)",
                  background: "var(--br-surface, rgba(255,255,255,0.78))",
                }}
              />

              <button
                type="submit"
                style={{
                  marginTop: 12,
                  padding: "10px 16px",
                  border: "1px solid rgba(var(--br-primary-rgb, 14,90,165), 0.20)",
                  borderRadius: "var(--br-card-radius, 14px)",
                  background: `linear-gradient(135deg, ${BRAND} 0%, ${BRAND2} 120%)`,
                  color: "white",
                  fontFamily: "Manrope, sans-serif",
                  fontWeight: 900,
                  cursor: "pointer",
                  boxShadow: "var(--br-shadow, 0 12px 26px rgba(var(--br-primary-rgb, 14,90,165), 0.18))",
                }}
              >
                Submit feedback
              </button>
            </form>
          </Modal>

          <Tour
        accentColor="#7057F6"
            steps={tourSteps}
            style={{ color: "black" }}
            isOpen={isTourOpen}
            onRequestClose={() => setIsTourOpen(false)}
          />

          {/* MAIN SIDEBAR */}
          <Box className="sl-borrower-sidebar"
            display="flex"
            flexDirection="column"
            justifyContent="flex-start"
            style={{
              height: "100vh",
              padding: "14px 0px 14px 12px",
              width: "100%",
            }}
          >
            <div className="sl-borrower-sidebar-panel" style={glassPanel}>
              {/* Top Area */}
              <div>
                <div style={{ padding: "18px 16px 8px 16px" }}>
                  <div style={{ padding: "10px 6px 6px 6px" }}>
                    <img
                      src={newLogo}
                      style={{ width: "80%", objectFit: "contain" }}
                      alt=""
                    />
                  </div>

                  <div
                    style={{ display: "flex", gap: 10, alignItems: "center" }}
                  >
                    <Link
                      style={{
                        padding: "10px 14px",
                        color: "white",
                        background: verifiedStatus
                          ? `linear-gradient(135deg, ${BRAND} 0%, ${BRAND2} 120%)`
                          : "rgba(148,163,184,0.7)",
                        borderRadius: 999,
                        cursor: "pointer",
                        textDecoration: "none",
                        fontFamily: "Manrope, sans-serif",
                        fontWeight: 900,
                        fontSize: 12,
                        boxShadow: verifiedStatus
                          ? "var(--br-shadow, 0 12px 26px rgba(var(--br-primary-rgb, 14,90,165), 0.18))"
                          : "none",
                        border: verifiedStatus
                          ? "1px solid rgba(var(--br-primary-rgb, 14,90,165), 0.20)"
                          : "1px solid rgba(148,163,184,0.25)",
                      }}
                      to={"/stg-b-profile"}
                      onClick={() => setSelected("Profile")}
                    >
                      {verifiedStatus ? "Verified" : "Unverified"}
                    </Link>

                    <Tooltip
                      overlayStyle={{ fontSize: 14, zIndex: 9999 }}
                      placement="topRight"
                      title="This represents the status in which your profile is verified by the platform. Verified profiles build better credibility with lenders."
                    >
                      <div
                        style={{
                          height: 28,
                          width: 28,
                          borderRadius: 999,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          background: "var(--br-surface, rgba(255,255,255,0.70))",
                          border: "1px solid rgba(148,163,184,0.22)",
                          boxShadow: "var(--br-shadow, 0 10px 22px rgba(2,8,23,0.06))",
                          cursor: "pointer",
                        }}
                      >
                        <QuestionOutlined
                          style={{ fontSize: 12, color: "rgba(15,23,42,0.55)" }}
                        />
                      </div>
                    </Tooltip>
                  </div>

                  {AccountManagerExist ? (
                    <div
                      className="mui_button"
                      onClick={() => setAccountmanagerModalIsOpen(true)}
                      style={{
                        marginTop: 10,
                        padding: "10px 14px",
                        borderRadius: "var(--br-card-radius, 16px)",
                        color: "white",
                        background: `linear-gradient(135deg, ${BRAND} 0%, ${BRAND2} 120%)`,
                        display: "flex",
                        alignItems: "center",
                        gap: 10,
                        fontFamily: "Manrope, sans-serif",
                        fontWeight: 900,
                        fontSize: 13,
                        boxShadow: "var(--br-shadow, 0 12px 26px rgba(var(--br-primary-rgb, 14,90,165), 0.18))",
                        border: "1px solid rgba(var(--br-primary-rgb, 14,90,165), 0.20)",
                      }}
                    >
                      <GroupsIcon style={{ color: "white", fontSize: 20 }} />
                      Account Manager
                    </div>
                  ) : null}
                </div>

                {/* Nav Items */}
                <Menu
                  mode="inline"
                  defaultSelectedKeys={[selected]}
                  selectedKeys={[selected]}
                  style={menuBaseStyle}
                >
                  <div style={{ overflowX: "hidden" }}>
                    <div
                      style={{
                        height: "100%",
                        overflowY: "visible",
                        overflowX: "visible",
                        paddingRight: 5,
                        paddingLeft: 14,
                        scrollbarGutter: "stable",
                      }}
                    >
                      <Item
                        title="Dashboard"
                        to="/b-dashboard"
                        icon={
                          <img
                            src={dashboard_pressed}
                            alt=""
                            width={12}
                            height={12}
                          />
                        }
                        icon2={
                          <img
                            src={dashboard_ico}
                            alt=""
                            width={12}
                            height={12}
                          />
                        }
                        selected={selected}
                        setSelected={setSelected}
                      />

                      <Item
                        title="Messages"
                        to="/b-messages"
                        icon={
                          <ForumIcon
                            style={{
                              fontSize: 18,
                              marginLeft: -3,
                              color: BRAND,
                            }}
                          />
                        }
                        icon2={
                          <ForumIcon
                            style={{
                              fontSize: 18,
                              marginLeft: -3,
                              color: "rgba(0,0,0,0.30)",
                            }}
                          />
                        }
                        selected={selected}
                        setSelected={setSelected}
                      />

                      <Item
                        title="Loan"
                        to="/b-personal-loans"
                        icon={
                          <img
                            src={loan_pressed}
                            alt=""
                            width={12}
                            height={12}
                          />
                        }
                        icon2={
                          <img src={loan_ico} alt="" width={12} height={12} />
                        }
                        selected={selected}
                        setSelected={setSelected}
                      />

                      <Item
                        title2="Money Lender Loans"
                        to="/b-personal-loans"
                        icon={" "}
                        icon2={" "}
                        selected={selected}
                        setSelected={setSelected}
                      />

                      <Item
                        className={"step3"}
                        title2="Corporate Loan"
                        to="/b-loan-hub"
                        icon={" "}
                        icon2={" "}
                        selected={selected}
                        setSelected={setSelected}
                      />

                      <Item
                        title2="Property Pledge Loan"
                        to="/b-instant-prop-term-loan"
                        icon={" "}
                        icon2={" "}
                        selected={selected}
                        setSelected={setSelected}
                        isNew
                      />

                      {!loanExist ? (
                        <Item
                          title="Free CBS Report"
                          to="/b-cbs-campaign"
                          icon={
                            <FolderSpecialIcon
                              style={{
                                fontSize: 18,
                                marginLeft: -3,
                                color: BRAND,
                              }}
                            />
                          }
                          icon2={
                            <FolderSpecialIcon
                              style={{
                                fontSize: 18,
                                marginLeft: -3,
                                color: "rgba(15,23,42,0.30)",
                              }}
                            />
                          }
                          selected={selected}
                          setSelected={setSelected}
                          blinking={true}
                        />
                      ) : null}

                      <Item
                        title="Tools"
                        to="/b-document-vault"
                        icon={
                          <img
                            src={loan_pressed}
                            alt=""
                            width={12}
                            height={12}
                            style={{ opacity: 1 }}
                          />
                        }
                        icon2={
                          <img
                            src={loan_ico}
                            alt=""
                            width={12}
                            height={12}
                            style={{ opacity: 0.85 }}
                          />
                        }
                        selected={selected}
                        setSelected={setSelected}
                      />

                      <Item
                        title2="Document Vault"
                        to="/b-document-vault"
                        icon={" "}
                        icon2={" "}
                        selected={selected}
                        setSelected={setSelected}
                      />
                    </div>
                  </div>
                </Menu>
              </div>

              {/* Bottom Actions */}
              <div className="sl-borrower-sidebar-bottom" style={{ padding: "10px 16px 16px 16px" }}>
                <div style={{ display: "grid", gap: 10 }}>
                  <div
                    onClick={() => setFeedbackModal(true)}
                    style={{
                      cursor: "pointer",
                      background: "var(--br-surface, rgba(255,255,255,0.70))",
                      borderRadius: "var(--br-card-radius, 16px)",
                      padding: "12px 14px",
                      boxShadow: "var(--br-shadow, 0 10px 22px rgba(2,8,23,0.06))",
                      border: "1px solid rgba(148,163,184,0.22)",
                      display: "flex",
                      alignItems: "center",
                      gap: 10,
                    }}
                  >
                    <ReviewsIcon
                      style={{ color: "rgba(15,23,42,0.55)", fontSize: 20 }}
                    />
                    <p
                      style={{
                        fontFamily: "Manrope, sans-serif",
                        fontWeight: 900,
                        fontSize: 13,
                        color: "rgba(15,23,42,0.70)",
                        margin: 0,
                      }}
                    >
                      Feedback
                    </p>
                  </div>

                  <div
                    onClick={() => setIsTourOpen(true)}
                    style={{
                      cursor: "pointer",
                      background: "var(--br-surface, rgba(255,255,255,0.70))",
                      borderRadius: "var(--br-card-radius, 16px)",
                      padding: "12px 14px",
                      boxShadow: "var(--br-shadow, 0 10px 22px rgba(2,8,23,0.06))",
                      border: "1px solid rgba(148,163,184,0.22)",
                      display: "flex",
                      alignItems: "center",
                      gap: 10,
                    }}
                  >
                    <TourIcon
                      style={{ color: "rgba(15,23,42,0.55)", fontSize: 20 }}
                    />
                    <p
                      style={{
                        fontFamily: "Manrope, sans-serif",
                        fontWeight: 900,
                        fontSize: 13,
                        color: "rgba(15,23,42,0.70)",
                        margin: 0,
                      }}
                    >
                      Dashboard Tour
                    </p>
                  </div>
                </div>

                <div style={{ marginTop: 12 }}>
                  <Menu
                    mode="inline"
                    defaultSelectedKeys={[selected]}
                    selectedKeys={[selected]}
                    style={{ background: "transparent", borderRight: "none" }}
                  >
                    <Item
                      className="step2"
                      title="Profile"
                      to="/stg-b-profile"
                      icon={
                        <img
                          src={profile_pressed}
                          alt=""
                          width={12}
                          height={12}
                        />
                      }
                      icon2={
                        <img src={profile_ico} alt="" width={12} height={12} />
                      }
                      selected={selected}
                      setSelected={setSelected}
                    />

                    <Item3
                      title="Log Out"
                      icon={
                        <LockIcon
                          style={{
                            fontSize: 18,
                            marginLeft: -3,
                            color: "rgba(239,68,68,0.95)",
                          }}
                        />
                      }
                      icon2={
                        <LockIcon
                          style={{
                            fontSize: 18,
                            marginLeft: -3,
                            color: "rgba(15,23,42,0.45)",
                          }}
                        />
                      }
                      to="#"
                      onClick={(event) => handleLogout(event)}
                      disabled={isLoading}
                    />
                  </Menu>
                </div>
              </div>
            </div>
          </Box>
        </>
      ) : (
        <div>
          <BurgerMenu
            menuClassName="sl-borrower-mobile-menu"
            left
            width={"100%"}
            isOpen={menuIsOpen}
            onStateChange={(state) => setMenuIsOpen(state.isOpen)}
            customCrossIcon={false}
            customBurgerIcon={
              <Hamburger
                toggled={menuIsOpen}
                toggle={handleToggleMenu}
                size={24}
              />
            }
            styles={burgerMenuStyles}
          >
            <div
              style={{
                minHeight: "100vh",
                display: "flex",
                justifyContent: "center",
                paddingTop: 18,
                paddingBottom: 18,
              }}
            >
              <div
                className="sl-borrower-sidebar-panel sl-borrower-mobile-panel"
                style={{
                  width: "100%",
                  maxWidth: 560,
                  ...mobileGlassPanel,
                  padding: "14px",
                }}
              >
                {/* ===== Top area (match desktop) ===== */}
                <div style={{ padding: "14px 12px 8px 12px" }}>
                  <div
                    style={{
                      padding: "10px 6px 6px 6px",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <img
                      src={newLogo}
                      style={{ width: "80%", objectFit: "contain" }}
                      alt=""
                    />
                    <div
                      onClick={() => setMenuIsOpen(false)}
                      style={{
                        marginLeft: "auto",
                        height: 34,
                        width: 34,
                        borderRadius: 999,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        background: "var(--br-surface, rgba(255,255,255,0.70))",
                        border: "1px solid rgba(148,163,184,0.22)",
                        boxShadow: "var(--br-shadow, 0 10px 22px rgba(2,8,23,0.06))",
                        cursor: "pointer",
                        userSelect: "none",
                        fontWeight: 900,
                        color: "rgba(15,23,42,0.65)",
                        fontFamily: "Manrope, sans-serif",
                      }}
                    >
                      ✕
                    </div>
                  </div>

                  {/* <div
                    style={{ display: "flex", gap: 10, alignItems: "center" }}
                  >
                    <Link
                      style={{
                        padding: "10px 14px",
                        color: "white",
                        background: verifiedStatus
                          ? `linear-gradient(135deg, ${BRAND} 0%, ${BRAND2} 120%)`
                          : "rgba(148,163,184,0.7)",
                        borderRadius: 999,
                        cursor: "pointer",
                        textDecoration: "none",
                        fontFamily: "Manrope, sans-serif",
                        fontWeight: 900,
                        fontSize: 12,
                        boxShadow: verifiedStatus
                          ? "0 12px 26px rgba(14,90,165,0.18)"
                          : "none",
                        border: verifiedStatus
                          ? "1px solid rgba(14,90,165,0.20)"
                          : "1px solid rgba(148,163,184,0.25)",
                      }}
                      to={"/stg-b-profile"}
                      onClick={() => {
                        setSelected("Profile");
                        setMenuIsOpen(false);
                      }}
                    >
                      {verifiedStatus ? "Verified" : "Unverified"}
                    </Link>

                    <Tooltip
                      overlayStyle={{ fontSize: 14, zIndex: 9999 }}
                      placement="topRight"
                      title="This represents the status in which your profile is verified by the platform. Verified profiles build better credibility with lenders."
                    >
                      <div
                        style={{
                          height: 28,
                          width: 28,
                          borderRadius: 999,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          background: "rgba(255,255,255,0.70)",
                          border: "1px solid rgba(148,163,184,0.22)",
                          boxShadow: "0 10px 22px rgba(2,8,23,0.06)",
                          cursor: "pointer",
                        }}
                      >
                        <QuestionOutlined
                          style={{ fontSize: 12, color: "rgba(15,23,42,0.55)" }}
                        />
                      </div>
                    </Tooltip>


                  </div> */}

                  {/* {AccountManagerExist ? (
                    <div
                      className="mui_button"
                      onClick={() => setAccountmanagerModalIsOpen(true)}
                      style={{
                        marginTop: 10,
                        padding: "10px 14px",
                        borderRadius: 16,
                        color: "white",
                        background: `linear-gradient(135deg, ${BRAND} 0%, ${BRAND2} 120%)`,
                        display: "flex",
                        alignItems: "center",
                        gap: 10,
                        fontFamily: "Manrope, sans-serif",
                        fontWeight: 900,
                        fontSize: 13,
                        boxShadow: "0 12px 26px rgba(14,90,165,0.18)",
                        border: "1px solid rgba(14,90,165,0.20)",
                        cursor: "pointer",
                      }}
                    >
                      <GroupsIcon style={{ color: "white", fontSize: 20 }} />
                      Account Manager
                    </div>
                  ) : null} */}
                </div>

                {/* divider */}
                <div
                  style={{
                    height: 1,
                    background: "rgba(148,163,184,0.20)",
                    margin: "6px 10px 10px 10px",
                  }}
                />

                {/* ===== Nav (match desktop structure) ===== */}
                <div style={{ padding: "0 6px" }}>
                  <MobileItem
                    title="Dashboard"
                    to="/b-dashboard"
                    icon={
                      <img
                        src={dashboard_pressed}
                        alt=""
                        width={12}
                        height={12}
                      />
                    }
                    icon2={
                      <img src={dashboard_ico} alt="" width={12} height={12} />
                    }
                    onClick={() => {
                      setSelected("Dashboard");
                      history.push("/b-dashboard");
                      window.scrollTo(0, 0);
                      setMenuIsOpen(false);
                    }}
                  />

                  <MobileItem
                    title="Messages"
                    to="/b-messages"
                    icon={
                      <ForumIcon
                        style={{ fontSize: 18, marginLeft: -3, color: BRAND }}
                      />
                    }
                    icon2={
                      <ForumIcon
                        style={{
                          fontSize: 18,
                          marginLeft: -3,
                          color: "rgba(0,0,0,0.30)",
                        }}
                      />
                    }
                    onClick={() => {
                      setSelected("Messages");
                      history.push("/b-messages");
                      window.scrollTo(0, 0);
                      setMenuIsOpen(false);
                    }}
                  />

                  <MobileItem
                    title="Loan"
                    to="/b-personal-loans"
                    icon={
                      <img src={loan_pressed} alt="" width={12} height={12} />
                    }
                    icon2={<img src={loan_ico} alt="" width={12} height={12} />}
                    onClick={() => {
                      setSelected("Loan");
                      history.push("/b-personal-loans");
                      window.scrollTo(0, 0);
                      setMenuIsOpen(false);
                    }}
                  />

                  <MobileItem
                    title2="Money Lender Loans"
                    to="/b-personal-loans"
                    icon={" "}
                    icon2={" "}
                    indent
                    onClick={() => {
                      setSelected("Personal Loans");
                      history.push("/b-personal-loans");
                      window.scrollTo(0, 0);
                      setMenuIsOpen(false);
                    }}
                  />

                  <MobileItem
                    title2="Corporate Loan"
                    to="/b-loan-hub"
                    icon={" "}
                    icon2={" "}
                    indent
                    onClick={() => {
                      setSelected("Corporate Loan");
                      history.push("/b-loan-hub");
                      window.scrollTo(0, 0);
                      setMenuIsOpen(false);
                    }}
                  />

                  <MobileItem
                    title2="Property Pledge Loan"
                    to="/b-instant-prop-term-loan"
                    icon={" "}
                    icon2={" "}
                    indent
                    isNew
                    onClick={() => {
                      setSelected("Property Pledge Loan");
                      history.push("/b-instant-prop-term-loan");
                      window.scrollTo(0, 0);
                      setMenuIsOpen(false);
                    }}
                  />

                  {!loanExist ? (
                    <MobileItem
                      title="Free CBS Report"
                      to="/b-cbs-campaign"
                      icon={
                        <FolderSpecialIcon
                          style={{ fontSize: 18, marginLeft: -3, color: BRAND }}
                        />
                      }
                      icon2={
                        <FolderSpecialIcon
                          style={{
                            fontSize: 18,
                            marginLeft: -3,
                            color: "rgba(15,23,42,0.30)",
                          }}
                        />
                      }
                      blinking
                      onClick={() => {
                        setSelected("Free CBS Report");
                        history.push("/b-cbs-campaign");
                        window.scrollTo(0, 0);
                        setMenuIsOpen(false);
                      }}
                    />
                  ) : null}

                  {/* <MobileItem
                    title="Tools"
                    to="/b-document-vault"
                    icon={
                      <img
                        src={loan_pressed}
                        alt=""
                        width={12}
                        height={12}
                        style={{ opacity: 1 }}
                      />
                    }
                    icon2={
                      <img
                        src={loan_ico}
                        alt=""
                        width={12}
                        height={12}
                        style={{ opacity: 0.85 }}
                      />
                    }
                    onClick={() => {
                      setSelected("Tools");
                      history.push("/b-document-vault");
                      window.scrollTo(0, 0);
                      setMenuIsOpen(false);
                    }}
                  />

                  <MobileItem
                    title2="Document Vault"
                    to="/b-document-vault"
                    icon={" "}
                    icon2={" "}
                    indent
                    onClick={() => {
                      setSelected("Document Vault");
                      history.push("/b-document-vault");
                      window.scrollTo(0, 0);
                      setMenuIsOpen(false);
                    }}
                  /> */}
                </div>

                {/* divider */}
                <div
                  style={{
                    height: 1,
                    background: "rgba(148,163,184,0.20)",
                    margin: "10px 10px 12px 10px",
                  }}
                />

                {/* ===== Bottom actions (match desktop) ===== */}
                <div style={{ padding: "0 12px 12px 12px" }}>
                  <div style={{ marginTop: 12 }}>
                    {/* Profile */}
                    <MobileItem
                      title="Profile"
                      to="/stg-b-profile"
                      icon={
                        <img
                          src={profile_pressed}
                          alt=""
                          width={12}
                          height={12}
                        />
                      }
                      icon2={
                        <img src={profile_ico} alt="" width={12} height={12} />
                      }
                      onClick={() => {
                        setSelected("Profile");
                        history.push("/stg-b-profile");
                        window.scrollTo(0, 0);
                        setMenuIsOpen(false);
                      }}
                    />

                    {/* Logout (use your existing handleLogout + keep red vibe) */}
                    <div
                      onClick={(event) => {
                        handleLogout(event);
                        setMenuIsOpen(false);
                      }}
                      style={{
                        cursor: isLoading ? "not-allowed" : "pointer",
                        opacity: isLoading ? 0.75 : 1,
                        margin: "10px 6px 6px 6px",
                        borderRadius: "var(--br-card-radius, 16px)",
                        padding: "12px 14px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: 12,
                        background:
                          "linear-gradient(180deg, rgba(239,68,68,0.10) 0%, rgba(239,68,68,0.05) 100%)",
                        border: "1px solid rgba(239,68,68,0.22)",
                        boxShadow: "var(--br-shadow, 0 14px 34px rgba(239,68,68,0.12))",
                        fontFamily: "Manrope, sans-serif",
                        fontWeight: 900,
                        fontSize: 13,
                        color: "rgba(15,23,42,0.78)",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 10,
                        }}
                      >
                        <LockIcon
                          style={{
                            fontSize: 18,
                            marginLeft: -3,
                            color: "rgba(239,68,68,0.95)",
                          }}
                        />
                        Log Out
                      </div>
                      <NavigateNextIcon
                        style={{ color: "rgba(15,23,42,0.35)" }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </BurgerMenu>
        </div>
      )}
    </>
  );
};
export default Sidebar;
